import { create } from "zustand";

export const useArchimedeFilters = create((set) => ({
    activeView: "control-room",
    datePreset: "7d",
    customDateStart: null,
    customDateEnd: null,
    selectedFeatures: [],
    status: "all",
    search: "",
    selectedClient: "",
    selectedUser: "",
    selectedService: "all",
    selectedModel: "all",
    minDurationMs: "",
    maxDurationMs: "",
    minTokens: "",
    sortBy: "latest",
    setFilters: (next) => set((state) => ({ ...state, ...next })),
    resetFilters: () =>
        set({
            datePreset: "7d",
            customDateStart: null,
            customDateEnd: null,
            selectedFeatures: [],
            status: "all",
            search: "",
            selectedClient: "",
            selectedUser: "",
            selectedService: "all",
            selectedModel: "all",
            minDurationMs: "",
            maxDurationMs: "",
            minTokens: "",
            sortBy: "latest",
        }),
}));
